/**
 * Behavior for sections/community-style-gallery.liquid, ported from the approved static
 * demo's inline <script> (homepage_demo_v1.html, lines 1668-1675) — the scroll-arrow
 * behavior for the horizontal photo track only.
 */
(function () {
  function init(root) {
    if (root.dataset.styleGalleryReady === 'true') return;
    root.dataset.styleGalleryReady = 'true';

    var track = root.querySelector('[data-style-track]');
    var prev = root.querySelector('[data-style-prev]');
    var next = root.querySelector('[data-style-next]');
    if (!track || !prev || !next) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function step() {
      return Math.max(260, track.clientWidth * 0.78);
    }

    prev.addEventListener('click', function () {
      track.scrollBy({ left: -step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });

    next.addEventListener('click', function () {
      track.scrollBy({ left: step(), behavior: reduceMotion ? 'auto' : 'smooth' });
    });
  }

  function initAll() {
    document.querySelectorAll('.style-zone').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector && event.target.querySelector('.style-zone');
    if (root) init(root);
  });
})();
